import { duration } from "moment";
import React, { createContext, useContext, useState } from "react";

const AllFilterBaseContext = createContext();

export const useAllFilterBaseContext = () => {
  const context = useContext(AllFilterBaseContext);
  if (!context) {
    throw new Error(
      "useAllFilterBaseContext must be used within an AllFilterBaseProvider"
    );
  }
  return context;
};

export const AllFilterBaseProvider = ({ children }) => {
  const [state, setState] = useState({
    sortByTime: [{ id: 1, title: "Recently Posted" }],
    sortByOptions: [],
    sortByTimeBxp: [{ id: 3, title: "Recently Posted" }],
    sortByExperience: [],
    pageNumber: 0,
    sortlanguage: "",
    sortAuction: "",
    sortposttype: [],
    sortexperttype: [],
    locationType: [],
    expertType: [],
    hiringType: [],
    searchlocation: "",
    remoteChecked: false,
    onSiteChecked: false,
    keywords: [],
    specialities: [],
    countries: [],
    cities: [],
    industries: [],
    subcategories: [],
    experienceLevel: "",
    minHourlyRate: "",
    maxHourlyRate: "",
    proposed: "",
    viewed: "",
    wishlist: "",
    rerender: "",
    searchexpert: "",
    search: "",
    allpostfiltertab: "",
    education: "",
    experience: "",
    deliverytype: [],
    location: "",
    duretion: "",
    totalbits: "",
    statustype: ""
  });

  const setStateAsync = (newState) =>
    new Promise((resolve) => {
      setState((prevState) => {
        const updatedState = { ...prevState, ...newState };
        resolve(updatedState);
        return updatedState;
      });
    });

  const clearAllFilterFields = async () => {
    await setStateAsync({
      sortByTime: [{ id: 1, title: "Recently Posted" }],
      sortByOptions: [],
      sortByTimeBxp: [{ id: 3, title: "Recently Posted" }],
      sortByExperience: [],
      statustype: "",
      pageNumber: 0,
      sortlanguage: "",
      sortAuction: "",
      sortposttype: [],
      sortexperttype: [],
      locationType: [],
      expertType: [],
      hiringType: [],
      searchlocation: "",
      remoteChecked: false,
      onSiteChecked: false,
      keywords: [],
      specialities: [],
      countries: [],
      cities: [],
      industries: [],
      subcategories: [],
      experienceLevel: "",
      minHourlyRate: "",
      maxHourlyRate: "",
      proposed: "",
      viewed: "",
      wishlist: "",
      rerender: "",
      searchexpert: "",
      search: "",
      allpostfiltertab: "",
      education: "",
      experience: "",
      deliverytype: [],
      location: "",
      duretion: "",
      totalbits: "",
    });
  };

  const locationTypeChange = async (type) => {
    const updatedTypes = state.locationType.includes(type)
      ? state.locationType.filter((t) => t !== type)
      : [...state.locationType, type];
    await setStateAsync({ pageNumber: 0, locationType: updatedTypes });
  };

  const expertTypeChange = async (type) => {
    const updatedTypes = state.expertType.includes(type)
      ? state.expertType.filter((t) => t !== type)
      : [...state.expertType, type];
    await setStateAsync({ pageNumber: 0, expertType: updatedTypes });
  };
  const setDeliverytype = async (type) => {
    const updatedTypes = state.deliverytype.includes(type)
      ? state.deliverytype.filter((t) => t !== type)
      : [...state.deliverytype, type];
    await setStateAsync({ pageNumber: 0, deliverytype: updatedTypes });
  };

  const hiringTypeChange = async (type) => {
    const updatedTypes = state.hiringType.includes(type)
      ? state.hiringType.filter((t) => t !== type)
      : [...state.hiringType, type];
    await setStateAsync({ pageNumber: 0, hiringType: updatedTypes });
  };

  const setAllpostfiltertab = async (value) =>
    await setStateAsync({ pageNumber: 0, allpostfiltertab: value });
  const setSortByTime = async (value) =>
    await setStateAsync({ pageNumber: 0, sortByTime: value, sortByTimeBxp: value });
  const setSortByOptions = async (value) =>
    await setStateAsync({ pageNumber: 0, sortByOptions: value });
  const setStatusType = async (value) =>
    await setStateAsync({ pageNumber: 0, statustype: value });
  const setSortByExperience = async (value) =>
    await setStateAsync({ pageNumber: 0, sortByExperience: value });
  const setSortLanguage = async (value) =>
    await setStateAsync({ pageNumber: 0, sortlanguage: value });
  const setSortAuction = async (value) =>
    await setStateAsync({ pageNumber: 0, sortAuction: value });
  const setSortPostType = async (type) => {
    await setStateAsync({ pageNumber: 0, sortposttype: [type] });
  };

  const setSortExpertType = async (type) => {
    const updatedTypes = state.sortexperttype.some((t) => t.id === type.id)
      ? state.sortexperttype.filter((t) => t.id !== type.id)
      : [...state.sortexperttype, type];
    await setStateAsync({ pageNumber: 0, sortexperttype: updatedTypes });
  };

  const setSearchexpert = async (value) =>
    await setStateAsync({ pageNumber: 0, searchexpert: value });
  const setLocation = async (value) =>
    await setStateAsync({ pageNumber: 0, location: value });
  const setSearchlocation = async (value) =>
    await setStateAsync({ pageNumber: 0, searchlocation: value });
  const setRemoteChecked = async (value) =>
    await setStateAsync({ pageNumber: 0, remoteChecked: value });
  const setOnSiteChecked = async (value) =>
    await setStateAsync({ pageNumber: 0, onSiteChecked: value });
  const setKeywords = async (value) =>
    await setStateAsync({ pageNumber: 0, keywords: value });
  const setSpecialities = async (value) =>
    await setStateAsync({ pageNumber: 0, specialities: value });
  const setCountryies = async (value) =>
    await setStateAsync({ pageNumber: 0, countries: value });
  const setCities = async (value) =>
    await setStateAsync({ pageNumber: 0, cities: value });
  const setIndustries = async (value) =>
    await setStateAsync({ pageNumber: 0, industries: value });
  const setSubcategories = async (value) =>
    await setStateAsync({ pageNumber: 0, subcategories: value });
  const setExperienceLevel = async (value) =>
    await setStateAsync({ pageNumber: 0, experienceLevel: value });
  const setMinHourlyRate = async (value) =>
    await setStateAsync({ pageNumber: 0, minHourlyRate: value });
  const setMaxHourlyRate = async (value) =>
    await setStateAsync({ pageNumber: 0, maxHourlyRate: value });
  const setPageNumber = async (value) =>
    await setStateAsync({ pageNumber: value });
  const setProposed = async (value) =>
    await setStateAsync({
      pageNumber: 0,
      proposed: 1,
      viewed: "",
      wishlist: "",
    });
  const setViewed = async (value) =>
    await setStateAsync({
      pageNumber: 0,
      proposed: "",
      viewed: 1,
      wishlist: "",
    });
  const setWishlist = async (value) =>
    await setStateAsync({
      pageNumber: 0,
      proposed: "",
      viewed: "",
      wishlist: 1,
    });
  const setListNull = async (value) =>
    await setStateAsync({
      pageNumber: 0,
      proposed: "",
      viewed: "",
      wishlist: "",
    });
  const setRerender = async (value) => await setStateAsync({ rerender: 1 });
  const typofpost = state?.sortposttype?.filter((value) => true);
  const setSearch = async (value) =>
    await setStateAsync({ pageNumber: 0, search: value });
  const setEducation = async (value) =>
    await setStateAsync({ pageNumber: 0, education: value });
  const setExperience = async (value) =>
    await setStateAsync({ pageNumber: 0, experience: value });

  const setDuretion = async (value) =>
    await setStateAsync({ pageNumber: 0, duration: value });
  const setTotalbits = async (value) =>
    await setStateAsync({ pageNumber: 0, totalbits: value });
  return (
    <AllFilterBaseContext.Provider
      value={{
        setState,
        setAllpostfiltertab,
        state,
        typofpost,
        setSortByTime,
        setStatusType,
        setSortByExperience,
        setSortLanguage,
        setSortAuction,
        setSortPostType,
        setSortExpertType,
        setSearchexpert,
        hiringTypeChange,
        locationTypeChange,
        setSearchlocation,
        setLocation,
        setRemoteChecked,
        setOnSiteChecked,
        setKeywords,
        setSpecialities,
        setCountryies,
        setCities,
        setIndustries,
        setSubcategories,
        setExperienceLevel,
        setMinHourlyRate,
        setMaxHourlyRate,
        clearAllFilterFields,
        setPageNumber,
        setProposed,
        setViewed,
        setWishlist,
        setListNull,
        setRerender,
        setSearch,
        setEducation,
        setExperience,
        setDeliverytype,
        setDuretion,
        setTotalbits,
        expertTypeChange,
        setSortByOptions
      }}
    >
      {children}
    </AllFilterBaseContext.Provider>
  );
};
